import { importProvidersFrom } from '@angular/core';
import { Routes } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { AdminModuleHeaderComponent } from '@offconon/admin/features/design-helper/admin-module-header';
import { AdminModuleMenuComponent } from '@offconon/admin/features/design-helper/admin-module-menu';
import { AdminModuleSelectorComponent } from '@offconon/admin/features/design-helper/admin-module-selector';
import { LayoutResolverService } from '@offconon/shared/features/layout';
import {
  MEDIA_GALLERY_FEATURE_KEY,
  MediaGalleryEffects,
  mediaGalleryReducer,
} from '@offconon/shared/features/media-gallery';

export const academyModuleAdminRoutingRoutes: Routes = [
  {
    path: '',

    children: [
      {
        path: '',
        loadComponent: () =>
          import('@offconon/admin/features/academy-module/academy-list-admin').then(
            (m) => m.AcademyListAdminComponent,
          ),
        resolve: { layout: LayoutResolverService },
        data: {
          layout: {
            leftBottom: {
              component: AdminModuleMenuComponent,
              inputs: { activepage: '/academy-admin', app_enum: 'apps' },
            },
            rightBottom: {
              component: AdminModuleSelectorComponent,
            },

            contentHeader: {
              component: AdminModuleHeaderComponent,
              inputs: {
                moduleData: {
                  title: 'OffConOn Administration',
                  subtitle: 'Academy',
                  menuItems: [
                    { icon: 'pi pi-home', route: '/academy-admin' },
                    { label: 'OffConOn Administration' },
                    { label: 'Academy' },
                  ],
                },
              },
            },
          },
        },
      },

      {
        path: 'create',
        loadComponent: () =>
          import('@offconon/admin/features/academy-module/academy-create-admin').then(
            (m) => m.AcademyCreateAdminComponent,
          ),
        resolve: { layout: LayoutResolverService },
        data: {
          layout: {
            leftBottom: {
              component: AdminModuleMenuComponent,
              inputs: { activepage: '/academy-admin', app_enum: 'apps' },
            },
            rightBottom: {
              component: AdminModuleSelectorComponent,
            },

            contentHeader: {
              component: AdminModuleHeaderComponent,
              inputs: {
                moduleData: {
                  title: 'OffConOn Administration',
                  subtitle: 'Academy',
                  menuItems: [
                    { icon: 'pi pi-home', route: '/academy-admin' },
                    { label: 'OffConOn Administration' },
                    { label: 'Academy' },
                    { label: 'Create' },
                  ],
                },
              },
            },
          },
        },
      },
      {
        path: 'edit/:id',
        loadComponent: () =>
          import('@offconon/admin/features/academy-module/academy-edit-admin').then(
            (m) => m.AcademyEditAdminComponent,
          ),

        resolve: { layout: LayoutResolverService },
        data: {
          layout: {
            leftBottom: {
              component: AdminModuleMenuComponent,
              inputs: { activepage: '/academy-admin', app_enum: 'apps' },
            },
            rightBottom: {
              component: AdminModuleSelectorComponent,
            },

            contentHeader: {
              component: AdminModuleHeaderComponent,
              inputs: {
                moduleData: {
                  title: 'OffConOn Administration',
                  subtitle: 'Academy',
                  menuItems: [
                    { icon: 'pi pi-home', route: '/academy-admin' },
                    { label: 'OffConOn Administration' },
                    { label: 'Academy' },
                    { label: 'Edit' },
                  ],
                },
              },
            },
          },
        },

        providers: [
          importProvidersFrom(
            StoreModule.forFeature(MEDIA_GALLERY_FEATURE_KEY, mediaGalleryReducer),
            EffectsModule.forFeature([MediaGalleryEffects]),
          ),
        ],
      },
      {
        path: ':parent_id',
        loadComponent: () =>
          import('@offconon/admin/features/academy-module/academy-list-admin').then(
            (m) => m.AcademyListAdminComponent,
          ),
        resolve: { layout: LayoutResolverService },
        data: {
          layout: {
            leftBottom: {
              component: AdminModuleMenuComponent,
              inputs: { activepage: '/academy-admin', app_enum: 'apps' },
            },
            rightBottom: {
              component: AdminModuleSelectorComponent,
            },

            contentHeader: {
              component: AdminModuleHeaderComponent,
              inputs: {
                moduleData: {
                  title: 'OffConOn Administration',
                  subtitle: 'Academy',
                  menuItems: [
                    { icon: 'pi pi-home', route: '/academy-admin' },
                    { label: 'OffConOn Administration' },
                    { label: 'Academy' },
                  ],
                },
              },
            },
          },
        },
        providers: [
          importProvidersFrom(
            StoreModule.forFeature(MEDIA_GALLERY_FEATURE_KEY, mediaGalleryReducer),
            EffectsModule.forFeature([MediaGalleryEffects]),
          ),
        ],
      },

      {
        path: 'preview/:id',
        loadComponent: () =>
          import('./academy-preview/academy-preview.component').then(
            (m) => m.AcademyPreviewComponent,
          ),
        resolve: { layout: LayoutResolverService },
        data: {
          layout: {
            leftBottom: {
              component: AdminModuleMenuComponent,
              inputs: { activepage: '/academy-admin', app_enum: 'apps' },
            },
            rightBottom: {
              component: AdminModuleSelectorComponent,
            },

            contentHeader: {
              component: AdminModuleHeaderComponent,
              inputs: {
                moduleData: {
                  title: 'OffConOn Administration',
                  subtitle: 'Academy',
                  menuItems: [
                    { icon: 'pi pi-home', route: '/academy-admin' },
                    { label: 'OffConOn Administration' },
                    { label: 'Academy' },
                  ],
                },
              },
            },
          },
        },
        providers: [
          importProvidersFrom(
            StoreModule.forFeature(MEDIA_GALLERY_FEATURE_KEY, mediaGalleryReducer),
            EffectsModule.forFeature([MediaGalleryEffects]),
          ),
        ],
      },
    ],
  },
];
